import { makeStyles } from '@mui/styles';

export const useQrCodeStyles = makeStyles((theme) => ({
  qrCode: {
    marginRight: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      minWidth: '190px'
    }
  }
}));
